import './App.css';
import LoginPage from './Pages/LoginPage';
import HomePage from './Pages/HomePage';
import GenrePage from './Pages/GenrePage';
import RegisterPage from './Pages/RegisterPage';
import AddMoviePage from './Pages/AddMoviePage';
import EditPage from './Pages/EditPage';
import { Routes, Route } from "react-router-dom";
import Protect from "./components/Protect"
import ProtectUser from "./components/ProtectUser"
import DetailPage from './Pages/DetailPage';
import AddGenre from './Pages/AddGenre';
import EditGenre from './Pages/EditGenre';
import PageNotFound from './Pages/PageNotFound';


function App() {
  return (
    <div>
      <Routes>
       <Route path="/" element={
        <Protect>
       <HomePage/>
       </Protect>
      }
       /> 
       <Route path="/genre" element={
         <Protect>
           <GenrePage/>
         </Protect>
       }/> 
       <Route path="/login" element={
       <ProtectUser>
       <LoginPage/>
       </ProtectUser>
       }/> 
       <Route path="/register" element={
       <Protect>
       <RegisterPage/>
       </Protect>
       }/> 
       <Route path="/edit/:id" element={
        <Protect>
       <EditPage/>
       </Protect>
      }/>
      <Route path="/addGenre" element={
        <Protect>
       <AddGenre/>
       </Protect>
      }/>
       <Route path="/editGenre/:id" element={
        <Protect>
       <EditGenre/>
       </Protect>
      }/>
      <Route path="/movie/:detailId/:slug" element={
        <Protect>
       <DetailPage/>
       </Protect>
      }/>
       <Route path="/add" element={
       <Protect>
        <AddMoviePage/>
       </Protect>
      }/> 
      <Route path='*' element={<PageNotFound/>}/>
      </Routes>
      
      {/* <HomePage/> */}
      {/* <GenrePage/> */}
      {/* <LoginPage/> */}
      {/* <RegisterPage/> */}
      {/* <AddMoviePage/> */}
    </div>
  );
}

export default App;
